import { ReactNode } from "react";

import { IllustrationContainerContainer } from "./styles";

interface IIllustrationContainerProps {
  children: ReactNode;
}

export const IllustrationContainer = ({
  children,
}: IIllustrationContainerProps) => {
  return (
    <IllustrationContainerContainer>{children}</IllustrationContainerContainer>
  );
};
